import React from "react";
import { useHeaderModel } from "../Header/useHeaderModel";
import { MegaMenuModel } from "../../../../api/headerApi.types";
import {
  ServicesBlock,
  ServicesBlockProps,
} from "../ServicesBlock/ServicesBlock";

interface ServicesBlockWrapperProps {
  currentPageId: number;
}

const mapMegaMenuToServicesBlockProps = (
  megaMenu: MegaMenuModel
): ServicesBlockProps => {
  return {
    blockTitle: "Our services and products",
    services: megaMenu?.items?.map((item) => ({
      description: item.megaMenuIntroduction,
      link: item.linkUrl,
      title: item.linkTitle,
      hideMegaMenuItemFromDesktop: item.hideMegaMenuItemFromDesktop
    })),
  };
};

export const ServicesBlockWrapper: React.FC<ServicesBlockWrapperProps> = ({
  currentPageId,
}) => {
  const { isLoading, data: headerModel } = useHeaderModel(
    currentPageId.toString()
  );

  if (isLoading) {
    return null;
  }
  if (!headerModel?.megaMenuModel) {
    return null;
  }

  return (
    <ServicesBlock
      {...mapMegaMenuToServicesBlockProps(headerModel?.megaMenuModel)}
    />
  );
};
